module.exports = __webpack_public_path__ + "schraegluftbilder.d92525.png";